import FeatherIcon from "feather-icons-react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Box, Button, Stack } from "@components/base";
import { useMultistepFormStore } from "@components/common/MultistepForm/MultistepForm.store";
import { useUserStore } from "@store/user";
import { useCreateQuestionConfig } from "@api";

const EditorButtonsTop: FC = () => {
  const { t } = useTranslation();
  const {
    activeSection,
    formSettings: {
      editMode,
      formBasics: { id },
    },
    setAddQuestionOpen,
    setCreateQuestionOpen,
    setSortQuestionsOpen,
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { createQuestionConfigEnabled } = useCreateQuestionConfig(user, id);

  return (
    createQuestionConfigEnabled &&
    activeSection &&
    editMode && (
      <Box>
        <Stack direction="row" spacing={1}>
          <Button
            variant="text"
            size="extraSmall"
            startIcon={<FeatherIcon icon="plus-circle" />}
            onClick={() => setAddQuestionOpen(true)}
          >
            {t("multistep.addQuestion")}
          </Button>
          <Button
            variant="text"
            size="extraSmall"
            startIcon={<FeatherIcon icon="file-plus" />}
            onClick={() => setCreateQuestionOpen(true)}
          >
            {t("multistep.createQuestion")}
          </Button>
          <Button
            variant="text"
            size="extraSmall"
            startIcon={<FeatherIcon icon="list" />}
            onClick={() => setSortQuestionsOpen(true)}
            color="warning"
          >
            {t("multistep.sortQuestions")}
          </Button>
        </Stack>
      </Box>
    )
  );
};

export default EditorButtonsTop;
